import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateJobTitle } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;
  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useUpdateJobTitle() {
  return useMutation({
    mutationFn: async ({ item, jobtitleId }) => {
      const payload = buildPayload(item);
      const response = await updateJobTitle({ item: payload, jobtitleId });
      return response;
    },
    onSuccess: () => {
      toast.success("Job Title Updated Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
